import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Typography,
} from '@material-ui/core';

interface Props {
	open: boolean;
	title: string;
	message?: string;
	onClose: () => void;
	onConfirm: () => void;
	buttonMessage?: string;
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	content?: any;
}

export function ConfirmationDialog({
	buttonMessage,
	content,
	message,
	onClose,
	onConfirm,
	open,
	title,
}: Props) {
	return (
		<Dialog onClose={onClose} open={open}>
			<DialogTitle disableTypography>
				<Typography variant={'h5'}> {title} </Typography>
			</DialogTitle>

			<DialogContent>
				{message && <DialogContentText>{message}</DialogContentText>}

				{content}
			</DialogContent>

			<DialogActions>
				<Button
					onClick={onClose}
					style={{ textTransform: 'capitalize' }}
				>
					Volver
				</Button>

				<Button
					color={'secondary'}
					disableElevation
					onClick={() => {
						onConfirm();
						onClose();
					}}
					style={{ textTransform: 'capitalize' }}
					variant={'contained'}
				>
					{buttonMessage || 'Sí, eliminar'}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
